import { Component, Inject, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Observable, map, of } from 'rxjs';
import { HuntingDistrictService } from '../hunting-district.service';
import { UserFeedbackService } from '../user-feedback.service';

@Component({
  selector: 'app-hunting-district-list-dialog',
  templateUrl: './hunting-district-list-dialog.component.html',
  styleUrl: './hunting-district-list-dialog.component.css'
})

export class HuntingDistrictListDialogComponent {
  optionForm: FormGroup;
  searchStr: string|undefined = undefined
  @Input() set loadingPagination( l: boolean) { this.showLoading = l }
  showLoading = false
  items = []
  filteredList$: Observable<any[]>
  huntingDistrVetAuthorities$: Map<string, any | undefined> = new Map();
    
  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    private fb:FormBuilder,
    private huntingService: HuntingDistrictService,
    private userFDService: UserFeedbackService,
    public dialogRef: MatDialogRef<HuntingDistrictListDialogComponent> ){
  }

  ngOnInit():void{
    this.items = this.data?.items ?? []
    this.filteredList$ = of(this.items)

    this.optionForm = this.fb.group({
      veterinaryAuthorityId:[ , Validators.required],
      veterinaryAuthorityName:[ ],
      loadHDFromId:[ ],
      hdistrictsVetAuthID:[ ],
      hdTemplate:[],
      hdTemplateName:[],
      listOption:[]
    })

    this.optionForm.get('hdistrictsVetAuthID').valueChanges.subscribe( items => {
      this.filteredList$ = of(items)
    })

  }

  get selectedTemplate() { 
    // return this.optionForm.get('loadHDFromId') && this.optionForm.get('hdistrictsVetAuthID')
    return this.optionForm.value.loadHDFromId && this.optionForm.value.hdistrictsVetAuthID
  }

  filterItems(searchString) {
    this.searchStr = searchString
    const list = this.items

    if(!this.selectedTemplate){
      if (!searchString)
        this.filteredList$ = of(this.items)
      else
        this.filteredList$ = of(this.items).pipe( map(el => el.filter(el => (el.name?.toLowerCase())?.includes(searchString))))
      
    }else{
      const veterinaryAuthorityId = this.optionForm.value?.veterinaryAuthorityId
      const list = this.huntingDistrVetAuthorities$.get(veterinaryAuthorityId)
      if (!searchString)
        this.filteredList$ = of(list)
      else
        this.filteredList$ = of(list).pipe( map((el:any) => el.filter(el => (el.name?.toLowerCase())?.includes(searchString))))

    }
  }

  setSelectedOption(id, name){
    if(!this.selectedTemplate)
      this.optionForm.patchValue({veterinaryAuthorityName: name, veterinaryAuthorityId:id})
    else
      this.optionForm.patchValue({hdTemplateName: name, hdTemplate:id})
  }

  async onSelectVetAuthId(){
    const veterinaryAuthorityId = this.optionForm.value?.veterinaryAuthorityId
    const vetDistricts = this.huntingDistrVetAuthorities$.get(veterinaryAuthorityId)
    if(vetDistricts){

    }else{
      try{
        this.userFDService.loading.emit(true)
        const hdList:any = await this.huntingService.loadHuntingDistrictsFromVetAuthId(veterinaryAuthorityId)

        hdList.sort((a,b) => a?.name?.localeCompare(b?.name));
        this.huntingDistrVetAuthorities$.set(veterinaryAuthorityId, hdList)
        this.optionForm.patchValue({loadHDFromId:veterinaryAuthorityId, hdistrictsVetAuthID:hdList  })
        this.userFDService.loading.emit(false)
      }catch(e){
        console.log(e)
        this.optionForm.patchValue({loadHDFromId:undefined, hdistrictsVetAuthID:[]  })
        this.huntingDistrVetAuthorities$.set(veterinaryAuthorityId, [])
        this.userFDService.loading.emit(false)
      }
    }

  }

  async onSelectTemplate(){
    const templateId = this.optionForm.value.hdTemplate
    const veterinaryAuthorityId = this.optionForm.value?.veterinaryAuthorityId
    const list = this.huntingDistrVetAuthorities$.get(veterinaryAuthorityId)

    let template = list?.find( t => t.id === templateId)
    template.templateId = templateId

    //-----> call to get outlines
    try{
      const data: any = await this.huntingService.loadOtlineFromTemplateHD(veterinaryAuthorityId, templateId )
      template = data
      data.templateId = templateId
  
    }catch(e){console.log(e)}

    this.dialogRef.close(template)
    
  }

}
